// extracted by mini-css-extract-plugin
export default {"text":"style_text__gKlIw","infoWrapper":"style_infoWrapper__U1MoK","info":"style_info__V3f+n","icon":"style_icon__dBZnH"};